var rich_content_viewer_default = {
  "fontElementMap": "Ys8cJ",
  "wrapper": "bLmv2",
  "pluginContainerMobile": "-TV89",
  "viewer": "VHjKj",
  "android": "rxjL0",
  "rootedTraversedContent": "stZ-o",
  "atomic": "HYF7J",
  "toolbar": "xnKBe",
  "block": "SDQHD"
};
export {
  rich_content_viewer_default as default
};
//# sourceMappingURL=rich-content-viewer-scss.js.map
